import React from 'react'


export default function Footer() {

    return (
        <div>
            <div>

                <footer id="footer" className="container-fluid">
                    <div className="MaxWidth940">
                        <div className="row footer-row">
                            <div id="footer_document" className="col-sm-4">
                                <p className="title pl-0">TIX</p>
                                <div className="row w-100 content-document">
                                    <div className="col-sm-6 col-xs-6 ">
                                        <a href="https://tix.vn/faq" >FAQ</a>
                                        <a href="https://tix.vn/brand-guideline/">Brand Guidelines</a>
                                    </div>
                                    <div className="col-sm-6">
                                        <a href="https://tix.vn/thoa-thuan-su-dung">Thỏa thuận sử dụng</a>
                                        <a href="https://tix.vn/chinh-sach-bao-mat">Chính sách bảo mật</a>
                                    </div>
                                </div>
                            </div>
                            <div id="footer_connect" className="col-sm-4">
                                <p className=" title pl-0">Đối tác</p>
                                <div className="row col-sm-12 partnerLine">
                                    <a href="https://www.cgv.vn" target="_blank" rel="noreferrer" >
                                        <img className="iconConnect" src="./img/logo/CGV-logo.png" alt="CGV" />
                                    </a>
                                    <a href="https://www.bhdstar.vn/"  target="_blank" rel="noreferrer" >
                                        <img className="iconConnect" src="./img/logo/BHD-logo.png" alt="BHD" />
                                    </a>
                                    <a href="http://cinestar.com.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/cinestar-logo.png" alt="Cinestar" />
                                    </a>
                                    <a href="http://ddcinema.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/DDC-logo.png" alt="ddcinema" />
                                    </a>
                                    <a href="https://www.galaxycine.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/galaxy-cinema-logo.png" alt="GalaxyCinema" />
                                    </a>
                                </div>
                                <div className="row col-sm-12 partnerLine">
                                    <a href="https://www.indovinabank.com.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/ivb-logo.png" alt="IBV"/>
                                    </a>
                                    <a href="https://laban.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/laban-logo.png" alt="Laban" />
                                    </a>
                                    <a href="#https://www.megagscinemas.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/megaGS-logo.png" alt="megaGS" />
                                    </a>
                                    <a href="http://starlight.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/starlight-logo.png" alt="Starlight" />
                                    </a>
                                    <a href="https://touchcinema.com/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/touch-logo.png" alt="TouchCinema" />
                                    </a>
                                </div>
                                <div className="row col-sm-12 partnerLine">
                                    <a href="https://portal.vietcombank.com.vn/Pages/Home.aspx" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/vietcombank-logo.png" alt="vietcombank" />
                                    </a>
                                    <a href="https://www.vietinbank.vn/web/home/vn/ind" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/vietin-logo.png" alt="viettin" />
                                    </a>
                                    <a href="https://www.zion.com/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/zion-logo.jpg" alt="zion" />
                                    </a>
                                    <a href="https://zalopay.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/zalo_logo.png" alt="zalopay" />
                                    </a>
                                    <a href="http://cinestar.com.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/logo2.png" alt="cinestar" />
                                    </a>
                                </div>
                                <div className="row col-sm-12 partnerLine">
                                    <a href="https://webv3.123go.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/123go-logo.png" alt="123go" />
                                    </a>
                                    <a href="https://www.zion.com/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/zion-logo.jpg" alt="zion" />
                                    </a>
                                    <a href="https://megags.vn/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/logo5.png" alt="mega" />
                                    </a>
                                    <a href="https://www.vietinbank.vn/web/home/vn/index.html" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/vietin-logo.png" alt="logo" />
                                    </a>
                                    <a href="https://touchcinema.com/" target="_blank" rel="noreferrer">
                                        <img className="iconConnect" src="./img/logo/touch-logo.png" alt="touchLogo" />
                                    </a>
                                </div>
                            </div>
                            <div id="footer_social" className="col-sm-4">
                                <div className="row">
                                    <div className="col-xs-6 text-center">
                                        <p className="title">MOBILE APP</p>
                                        <a href="https://apps.apple.com/vn/app/tix-%C4%91%E1%BA%B7t-v%C3%A9-nhanh-nh%E1%BA%A5t/id615186197" target="_blank" rel="noreferrer" title="apple app"><img className="social_image_logo" src="./img/logo/apple-logo.png" alt="TixMNoblie" /></a>
                                        <a href="https://play.google.com/store/apps/details?id=vn.com.vng.phim123" target="_blank" rel="noreferrer" title="android app"><img className="social_image_logo" src="./img/logo/android-logo.png" alt="TixSocail" /></a>
                                    </div>
                                    <div className="col-xs-6 text-center ml-4">
                                        <p className="title">SOCIAL</p>
                                        <a href="https://www.facebook.com/tix.vn/" target="_blank" rel="noreferrer" title="facebook"><img className="social_image_logo" src="./img/logo/facebook-logo.png" alt="Facebook" /></a>
                                        <a href="https://zalo.me/tixdatve" target="_blank" rel="noreferrer" title="zalo"><img className="social_image_logo" src="./img/logo/zalo-logo.png" alt="Zalo" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row " id="contentFooter">
                            <div className="col-sm-1 imgFooter">
                                <img className="zion_icon" src="./img/logo/zion-logo.jpg" alt="Zion" />
                            </div>
                            <div className="col-sm-9 infoFooter">
                                <span>TIX – SẢN PHẨM CỦA CÔNG TY CỔ PHẦN ZION</span>
                                <span>Địa chỉ: Z06 Đường số 13, Phường Tân Thuận Đông, Quận 7, Tp. Hồ
            Chí Minh, Việt Nam.</span>
                                <span>Giấy chứng nhận đăng ký kinh doanh số: 0101659783,<br />đăng ký
            thay đổi lần&nbsp;thứ&nbsp;30,
            ngày&nbsp;22&nbsp;tháng&nbsp;01&nbsp;năm&nbsp;2020 do
            Sở&nbsp;kế&nbsp;hoạch&nbsp;và&nbsp;đầu&nbsp;tư Thành phố Hồ Chí
            Minh cấp.</span>
                                <span>Số Điện Thoại (Hotline): 1900&nbsp;545&nbsp;436<br />Email:
            <a href="mailto:support@tix.vn" style={{ color: '#fb4226' }}>support@tix.vn</a></span>
                            </div>
                            <div className="col-sm-2 col-xs-12 imgFooter">
                                <a target="_blank" href="http://online.gov.vn/Home/WebDetails/62782" rel="noreferrer"><img className="imgBoCo" alt="Bộ Công Thương" title src="./img/logo/bocongthuong.png" /></a>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>

        </div >
    )
}
